/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect } from "react";
import {
  Autocomplete,
  Typography,
  TextField,
  Box,
  Button,
  Grid,
  useMediaQuery,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Close, Search, ChevronRight } from "@mui/icons-material";
import { connect } from "react-redux";
import { homeActions } from "actions";
import { homeService } from "../../services/home.service";

const ProfileInsuranceContainer = (props) => {
  const {
    insuranceData,
    selectedInsurance,
    onSelectInsurance,
    setOpenInfoDialog,
    contentInfo,
    //saveInsuranceData,
    organizationInfo,
  } = props;
  const [insuranceType, setInsuranceType] = useState(null);
  const [defaultInsuranceData, setDefaultInsuranceData] = useState(null);
  const matches = useMediaQuery("(max-width:600px)");
  const matchesMinWidth = useMediaQuery("(max-width:400px)");
  const [commericalInsuranceData, setCommericalInsuranceData] = useState({});
  const [govtInsuranceData, setGovtInsuranceData] = useState({});
  const [govtInsuranceAlertPopup, setGovtInsuranceAlertPopup] = useState(false);
  const [tempInsuranceData, setTempInsuranceData] = useState({});
  const [unInsuranceData, setUnInsuranceData] = useState({});

  const getSelectedOption = (event, item) => {
    if (item) {
      onSelectInsurance(item);
      setInsuranceType(null);
      props.saveInsuranceData(item);
    }
  };

  const insuranceSearch = (event) => {
    if (event?.target?.value && event.target.value.length > 2) {
      props.getInsutranceList(event.target.value);
    }
  };

  const notInsured = () => {
    getSelectedOption(null, {
      ...unInsuranceData,
    });
  };

  useEffect(() => {
    if (insuranceType) {
      console.log(defaultInsuranceData);
      homeService.getInsutranceDefaultText(insuranceType).then((res) => {
        setDefaultInsuranceData(res?.data);
      });
    }
    return () => {
      setDefaultInsuranceData(null);
    };
  }, [insuranceType]);

  useEffect(() => {
    if (
      contentInfo &&
      contentInfo.INSURANCE_HELP_V2 &&
      contentInfo.INSURANCE_HELP_V2.content
    ) {
      const govtInsData = contentInfo.INSURANCE_HELP_V2.contentParam.filter(
        (item) => item.value.type === "Y"
      )[0];
      const commericalInsData =
        contentInfo.INSURANCE_HELP_V2.contentParam.filter(
          (item) => item.value.type === "X"
        )[0];
      const unInsured = contentInfo.INSURANCE_HELP_V2.contentParam.filter(
        (item) => item.value.type === "Z"
      )[0];
      setCommericalInsuranceData({
        ...commericalInsData?.value,
        formularyText: commericalInsData?.displayText,
        name: commericalInsData?.displayText,
      });
      setGovtInsuranceData({
        ...govtInsData?.value,
        formularyText: govtInsData?.displayText,
        name: govtInsData?.displayText,
      });
      setUnInsuranceData({
        ...unInsured?.value,
        formularyText: unInsured?.displayText,
        name: unInsured?.displayText,
      });
    }
  }, [contentInfo]);

  return (
    <>
      <Grid>
        <Box>
          {selectedInsurance?.id !== commericalInsuranceData?.id &&
            selectedInsurance?.id !== govtInsuranceData?.id &&
            selectedInsurance?.id !== unInsuranceData?.id && (
              <Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "30px",
                }}
                component={"div"}
                variant="h3LatoBold"
              >
                {selectedInsurance?.name}
              </Typography>
            )}
          <Autocomplete
            freeSolo
            options={insuranceData}
            getOptionLabel={(option) => option?.name || ""}
            className="auto-complete-input"
            clearIcon={
              <Close
                onClick={() => props.resetInsuranceFilterData()}
                fontSize="small"
              />
            }
            filterOptions={(all) => {
              return all;
            }}
            renderOption={(event, option, { inputValue }) => {
              const name = option.name.replace(
                new RegExp(inputValue, "gi"),
                (match) => `<b>${match}</b>`
              );
              return (
                <Box
                  className="auto-complete-list-container"
                  key={option.id}
                  onClick={(event) => {
                    if (option.type === "Y") {
                      setTempInsuranceData(option);
                      setGovtInsuranceAlertPopup(true);
                    } else {
                      props.resetInsuranceFilterData();
                      getSelectedOption(event, option);
                    }
                  }}
                >
                  <Box
                    className="search-list-view"
                    dangerouslySetInnerHTML={{ __html: name }}
                  ></Box>
                  <ChevronRight className="right-icon" />
                </Box>
              );
            }}
            renderInput={(params) => (
              <Box>
                <Typography
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "30px",
                    fontSize: matchesMinWidth ? "14px" : "18px",
                  }}
                  component={"div"}
                  variant="h3LatoBold"
                >
                  Enter your Insurance for best results:
                </Typography>
                <Box sx={{ position: "relative" }} mt={1}>
                  <TextField
                    {...params}
                    variant="standard"
                    onChange={insuranceSearch}
                    inputProps={{
                      ...params.inputProps,
                      onKeyDown: (e) => {
                        if (e.key === "Enter" && insuranceData?.length) {
                          getSelectedOption(undefined, insuranceData[0]);
                        }
                      },
                    }}
                  />
                  <Search
                    sx={{
                      color: `${organizationInfo?.colorSchemeJson?.primaryButtonColor} !important`,
                    }}
                    className="search-icon"
                  />
                </Box>
              </Box>
            )}
          />
          <Box mb={3} sx={{ textAlign: "center", marginTop: "15vh" }}></Box>
        </Box>

        <Grid>
          <Typography
            sx={{
              display: "flex",
              justifyContent: "center",
              padding: "10px 10px 15px 0px",
              fontSize: matches ? 12 : 16,
            }}
            variant="h3LatoRegular"
          >
            If unable to select insurance, choose below:
          </Typography>
          <>
            {commericalInsuranceData?.id && (
              <Box sx={{ display: "flex", justifyContent: "center" }} mb={3}>
                <Button
                  onClick={() => {
                    getSelectedOption(undefined, {
                      ...commericalInsuranceData,
                    });
                    setInsuranceType(commericalInsuranceData?.type);
                  }}
                  id="private"
                  sx={{
                    width: "405px !important",
                    minWidth: matches ? "275px" : "330px !important",
                    fontSize: matches ? 12 : 16,
                    textTransform: "uppercase",
                    color:
                      selectedInsurance?.id === commericalInsuranceData?.id
                        ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor} !important`
                        : "",
                    backgroundColor:
                      selectedInsurance?.id === commericalInsuranceData?.id
                        ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.backgroundColor} !important`
                        : "",
                  }}
                  variant="large"
                >
                  {commericalInsuranceData?.name}
                </Button>
              </Box>
            )}
          </>
          <>
            {govtInsuranceData?.id && (
              <Box sx={{ display: "flex", justifyContent: "center" }} mb={3}>
                <Button
                  onClick={() => {
                    getSelectedOption(undefined, {
                      ...govtInsuranceData,
                    });

                    setInsuranceType(govtInsuranceData?.type);
                  }}
                  id="medicare"
                  sx={{
                    width: "405px !important",
                    minWidth: matches ? "275px" : "330px !important",
                    fontSize: matches ? 12 : 16,
                    textTransform: "uppercase",
                    color:
                      selectedInsurance?.id === govtInsuranceData.id
                        ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor} !important`
                        : "",
                    backgroundColor:
                      selectedInsurance?.id === govtInsuranceData.id
                        ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.backgroundColor} !important`
                        : "",
                  }}
                  variant="large"
                >
                  {govtInsuranceData?.name}
                </Button>
              </Box>
            )}
          </>
          <>
            {unInsuranceData?.id && (
              <Box sx={{ display: "flex", justifyContent: "center" }} mb={3}>
                <Button
                  id="unInsuredBtn"
                  sx={{
                    width: "405px !important",
                    minWidth: matches ? "275px" : "330px !important",
                    fontSize: matches ? 12 : 16,
                    color:
                      selectedInsurance?.type === "Z"
                        ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor} !important`
                        : "",
                    backgroundColor:
                      selectedInsurance?.type === "Z"
                        ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.backgroundColor} !important`
                        : "",
                    textTransform: "uppercase",
                  }}
                  variant="large"
                  onClick={() => {
                    // clearCommercialInsurance();
                    notInsured();
                  }}
                >
                  {unInsuranceData?.name}
                </Button>
              </Box>
            )}
          </>
        </Grid>
      </Grid>

      <Grid
        sx={{ width: "100%", justifyContent: "center", display: "flex" }}
        item
        pt={2}
        xs={12}
      >
        <Typography
          sx={{ width: matchesMinWidth ? "90%" : "60%", textAlign: "center" }}
          variant="h3LatoMedium"
        >
          I do not wish to check if i am eligible for manufacture savings
          coupons, nor compare lowest available discount card pricing to my
          estimated copay, or see less expensive couverd alternatives within my
          plan within my results
        </Typography>
      </Grid>

      <Box sx={{ textAlign: "center" }}>
        <Button
          variant="outline"
          className="info-done-button"
          onClick={() => {
            if (!insuranceType) {
              setOpenInfoDialog(false);
            }
            setInsuranceType(null);
          }}
          sx={{
            marginTop: "10px",
            minWidth: { xs: "150px", sm: "150px", md: "300px" },
            // textDecoration: "underline",
          }}
        >
          CANCEL
        </Button>
      </Box>
      <Box>
        <Dialog
          open={govtInsuranceAlertPopup}
          // onClose={closeInsuranceInfo}
          className="app-dialog app-dialog-max-width"
          sx={{
            marginRight: matches ? undefined : "20%",
            marginLeft: matches ? undefined : "20%",
          }}
        >
          <DialogContent>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <Typography variant="h3LatoBold">
                You have selected a Medicare/Medicaid/Govt plan.
                <br />
                Is this correct?
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
                variant="outline"
                sx={{ fontFamily: "Lato-Bold", marginRight: "10px" }}
                onClick={() => {
                  getSelectedOption(undefined, tempInsuranceData);
                  props.resetInsuranceFilterData();
                  setGovtInsuranceAlertPopup(false);
                  setTempInsuranceData({});
                }}
              >
                Yes
              </Button>
              <Button
                variant="outline"
                sx={{ fontFamily: "Lato-Bold" }}
                onClick={() => {
                  setTempInsuranceData({});
                  setGovtInsuranceAlertPopup(false);
                }}
                // onClick={() => onCancel()}
              >
                No, I'll reselect
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    isProgress: state.insuranceList.isProgress,
    selectedInsurance: state.insuranceList.selectedInsurance,
    insuranceData: state.insuranceList.data || [],
    contentInfo: state.contentType.data,
    organizationInfo: state.organizationInfo.data || {},
  };
};

const mapDispatchToProps = {
  getInsutranceList: (value, type) =>
    homeActions.getInsutranceList(value, type),
  resetInsuranceFilterData: () => homeActions.resetInsuranceFilterData(),
  saveInsuranceData: (value) => homeActions.saveInsuranceData(value),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileInsuranceContainer);
